import VueRouter from "vue-router";

let originPush = VueRouter.prototype.push
let originReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function (location, resolve, reject) {
    if (resolve && reject) {
        originPush.call(this, location, resolve, reject)
    } else {
        originPush.call(this, location, () => {
        }, () => {
        })
    }
}
VueRouter.prototype.replace = function (location, resolve, reject) {
    if (resolve && reject) {
        originReplace.call(this, location, resolve, reject)
    } else {
        originReplace.call(this, location, () => {
        }, () => {
        })
    }
}

const router = new VueRouter({
    routes: [
        {
            path: '/',
            component: () => import("@/views/group/index.vue"),
            redirect: '/home',
            children: [
                {
                    path: '/home',
                    component: () => import("@/views/group/InvestorRelations/investor-relations.vue")
                },
                {
                    path: '/investor-relations/:key',
                    component: () => import("@/views/group/InvestorRelations/more.vue")
                },
                {
                    path: '/contact',
                    component: () => import("@/views/group/Contact/contact.vue")
                }
            ]
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0};
    },
})

export default router